<template>
  <div>
    <UITable
      :columns="columns"
      :rows="pagedEvents.map((e) => ({ ...e, actions: null }))"
    >
      <template #title="{ value, data: event }">
        {{ value }}

        <div v-if="eventType == 'webinars'">
          <a :href="event.url" target="_blank" class="webinar-link">
            More Info
          </a>
        </div>
      </template>

      <template #address="{ value, index }">
        <a
          href="#"
          @click.prevent="
            $emit('panToEvent', pagedEvents[index] as LiveCPDEvent)
          "
        >
          <span class="text-truncate">{{ value }}</span>
          <i class="fa fa-eye view-on-map"></i>
        </a>
      </template>

      <template #startTime="{ value }">
        {{ value?.toLocaleString() }}
      </template>

      <template #actions="{ data: event }">
        <UIButton tag="a" variant="success" target="_blank" :href="event.url">
          Register
        </UIButton>
      </template>
    </UITable>

    <UIPagination
      v-if="totalPages > 1"
      class="d-flex justify-content-center mt-4"
      v-model="currentPage"
      :count="totalPages"
    />
  </div>
</template>

<script setup lang="ts">
import UIButton from "@/components/UI/UIButton.vue";
import UIPagination from "@/components/UI/UIPagination.vue";
import UITable from "@/components/UI/UITable.vue";
import { computed, ref } from "vue";
import { CPDEventType, LiveCPDEvent } from "./EventsList.vue";
import { CPDEvent } from "./utils";

const PAGE_SIZE = 5;

const props = defineProps<{ eventType: CPDEventType; events: CPDEvent[] }>();
defineEmits<{ (e: "panToEvent", v: LiveCPDEvent): unknown }>();

const currentPage = ref<number>(0);
const totalPages = computed<number>(() =>
  Math.ceil(props.events.length / PAGE_SIZE)
);
const pagedEvents = computed<CPDEvent[]>(() =>
  props.events.slice(
    currentPage.value * PAGE_SIZE,
    currentPage.value * PAGE_SIZE + PAGE_SIZE
  )
);

const columns = computed(() =>
  props.eventType === "mash_events"
    ? {
        title: "Event",
        address: "Address",
        startTime: "Time",
        actions: "",
      }
    : {
        title: "Event",
        startTime: "Time",
        actions: "",
      }
);
</script>
